import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import { ca } from "date-fns/locale";
import { IdntMthdCdStateChng, AppDispatch } from "Stores/IdntMthdCdReducer";
import { useDispatch } from "react-redux";
import MembAccnDtlInfoInqApi from "Apis/MembAccnDtlInfoInqApi";
import MembOtpRegScrtApi from "Apis/MembOtpRegScrtApi";
import MembLvdRegApi from "Apis/MembLvdRegApi";
import MembOtpUnRegApi from "Apis/MembOtpUnRegApi";
import MembIdntMthdChngApi from "Apis/MembIdntMthdChngApi";
import { useState } from "react";
import ApiResultModal from "Components/ApiResultModal";

const KmcMoCallback = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const kmcApiTknrslt = urlParams.get('apiToken')||"";
    const kmcApiCertNumrslt = urlParams.get('certNum')||"";
    const athnPrpsCd = urlParams.get('athnPrpsCd')||"";
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const isMacDesktop = !isMobile && /Mac/i.test(navigator.platform || navigator.userAgent);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    useEffect(() => {
        MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt).then((resp) => {
            switch(resp.apiHdr.code){
                case "ATHN0000":
                    switch(athnPrpsCd){
                        case "MEMB_FIND":
                            if(resp.apiBody.appYn === "Y") {
                                return navigate("/Connect/MembFindId/List",{state:{idntMthdCd:"MBP"}});    
                            }
                            return navigate("/MembFindId/List",{state:{idntMthdCd:"MBP"}});
                        case "PWD_RSET":
                            if(resp.apiBody.appYn === "Y") {
                                return navigate("/Connect/MembFindPw/FindPwInput",{state:{idntMthdCd:"MBP",membId:resp.apiBody.loginId}});    
                            }
                            return navigate("/MembFindPw/FindPwInput",{state:{idntMthdCd:"MBP",membId:resp.apiBody.loginId}});
                        case "PWD_RSET_MYPAGE" :
                            if(resp.apiBody.appYn === "Y") {
                               return  MembAccnDtlInfoInqApi()
                                    .then((accnResp) => {
                                        navigate("/Connect/MyPage/PasswdChngInput", { state: { membAccnDtlInfo: accnResp.apiBody } });
                                    });
                            }
                            return  MembAccnDtlInfoInqApi()
                                    .then((accnResp) => {
                                        navigate("/MyPage/PasswdChngInput", { state: { membAccnDtlInfo: accnResp.apiBody } });
                                    });
                        case "EML_CHNG" :
                            if(resp.apiBody.appYn === "Y") {
                                return navigate("/Connect/MyPage/EmlChngInput");    
                            }
                            return navigate("/MyPage/EmlChngInput");
                        case "OTP_REG":
                             return MembOtpRegScrtApi()
                                    .then((resp) => {
                                        navigate("/MyPage/otpRegInput",{state:{otpScrt:resp.apiBody.otpScrt,qrCdImg:resp.apiBody.qrCdImg}});
                                    });
                        case "OTP_UNREG":
                            if(resp.apiBody.appYn === "Y") {
                             return MembOtpUnRegApi().then((resq)=>{
                                if(resq.apiHdr.code == "MEMB0000") {
                                    navigate(`/Connect/AppStrt`,{ state: { pageCd: "login" }, replace:true });
                                }});
                            }
                             return MembOtpUnRegApi().then((resq)=>{
                                if(resq.apiHdr.code == "MEMB0000") {
                                    navigate("/", { replace: true });
                                }});
                        case "OTP_UNREG_MYPAGE" :
                            return MembOtpUnRegApi().then((resq)=>{
                            if(resq.apiHdr.code == "MEMB0000") {
                                navigate("/MyPage", { replace: true });

                            }})
                        case "MTHD_CHNG" :
                            return navigate("/MyPage", { replace: true });
                                
                        case "MTHD_CHNG_PYMT" :
                            if (!isMobile ) {
                                window.close();
                                return;
                            }
                            return navigate("/GamePage/ShopLst?ctntKindCd=MNY&gameSvcCd=KRBBO", { replace: true });
                        case "PRNT_ATHN_PYMT" :
                            return navigate("/MyPage");
                        case "PRNT_ATHN":
                            dispatch(IdntMthdCdStateChng('EML'));
                            navigate("/MyPage");
                            return  
                        case "MEMB_LVD" :
                            return MembLvdRegApi().then((resp)=>{
                                switch(resp.apiHdr.code) {
                                    case "MEMB0000":    
                                        navigate("/");
                                    break;
                                }
                            });
                        case "MTHD_CHNG_APP" :
                            if (!isMobile ) {
                                window.close();
                                return;
                            }
                            return navigate("/Connect/AppStrt", { replace: true ,state: { pageCd: "login" }});
                        default: return navigate("/", { replace: true });
                    }
                case "MEMB3204":                    
                    openResultModal("휴대폰 본인인증 가입 가능 개수 초과", () => navigate("/", { replace: true }));
                    return;
                case "ATHN2312" :
                    openResultModal(resp.apiHdr.msg, () => {
                        if(resp.apiBody?.appYn === "Y") {
                            navigate("/Connect/Login");
                            return;
                        }
                        navigate("/");
                    });
                    return;
            }
            return navigate("/", { replace: true });
        });
    }, [])
    return (
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
        />
        <div className="container500 gameMnyDpstWrap">
           <p>처리중...</p>
        </div>
        </>
    )
}
export default KmcMoCallback;